import MarkdownIt from 'markdown-it';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Observable, Subject } from 'rxjs';
import { ApplicationFacade } from '@ridango/components';
import { BannerMessage, BannersFacade } from '@ridango/components/lib/banners';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { BannerUtils } from '../banner/banner.utils';

@Component({
    selector: 'rwidget-banner-details-page',
    templateUrl: './banner-details-page.component.html',
    styleUrls: ['./banner-details-page.component.scss']
})
export class BannerDetailsPageComponent implements OnInit, OnDestroy {
    public banner: BannerMessage;
    public infoStyle = false;
    public trafficInfoStyle = false;
    public warningStyle = false;
    public highContrastStyle = false;
    public isHighContrast = false;

    public markdown = new MarkdownIt();

    public readonly assetsPath$: Observable<string> = this.applicationFacade.assetsPath$;
    private readonly highContrast$: Observable<boolean> = this.applicationFacade.highContrast$;

    private componentDestroyed$ = new Subject<void>();

    constructor(
        private applicationFacade: ApplicationFacade,
        private bannersFacade: BannersFacade,
        private route: ActivatedRoute,
        private location: Location
    ) {}

    ngOnInit() {
        this.initialize();
        this.highContrastSubscriber();
        this.querySubscriber();
    }

    ngOnDestroy(): void {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    public redirectToPreviousPage(): void {
        this.location.back();
    }

    public renderedMarkdown(content: string): string {
        return this.markdown.render(content);
    }

    private initialize(): void {
        this.bannersFacade.getBanners();
    }

    private querySubscriber(): void {
        combineLatest([this.route.params, this.bannersFacade.banners$])
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(([params, banners]) => {
                const bannerId = params['bannerId'];

                if (bannerId && banners.length) {
                    this.banner = banners.find((banner) => banner.id === bannerId);
                    this.updateStyleFlags();
                }
            });
    }

    private highContrastSubscriber(): void {
        this.highContrast$.pipe(takeUntil(this.componentDestroyed$)).subscribe((value) => {
            this.isHighContrast = value;
            this.updateStyleFlags();
        });
    }

    private updateStyleFlags(): void {
        const { infoStyle, trafficInfoStyle, warningStyle, highContrastStyle } = BannerUtils.getStyleFlags(
            this.banner?.type,
            this.isHighContrast
        );

        this.infoStyle = infoStyle;
        this.trafficInfoStyle = trafficInfoStyle;
        this.warningStyle = warningStyle;
        this.highContrastStyle = highContrastStyle;
    }
}
